export const MAIL_TOOLKIT_SLUGS = new Set(['gmail', 'outlook'])
